import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface UpdateWaitListStatusParam {
  classId: string;
  enabled: boolean;
}

export const updateWaitListStatusAPI = async ({
  classId,
  enabled,
}: UpdateWaitListStatusParam) => {
  const resp = await baseAPI.patch<unknown>(`enrollments/${classId}/waitlist`, {
    enabled,
  });
  return resp.data;
};

export const useUpdateWaitListStatusMutation = () => {
  return useMutation({
    mutationFn: async (params: UpdateWaitListStatusParam) => {
      const response = await updateWaitListStatusAPI(params);
      return response;
    },
    onSuccess: (_, params) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.WAIT_LIST_SUMMARY, params.classId],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.CLASSES, params.classId],
      });
    },
  });
};
